import React, { Component } from 'react';
import spinner from '../../images/loading-spinner.gif';
import { translate } from 'react-i18next';
import Input from '../../components/Input';
import TypeOfCard from '../../components/TypeOfCard';
import { validateCard } from '../../helpers/card.js';

class Payment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fieldsValid: {},
            error: null
        }
    }

    handleValidate = ({ name, isValid }) => {
        this.setState({
            fieldsValid: {
                ...this.state.fieldsValid,
                [name]: isValid
            }
        })
    }

    handleCardNumber = (event) => {
        const { isValid, newValue } = validateCard({
            value: event.target.value,
            state: this.state.cardNumber
        })
        if (isValid) {
            this.props.handleCardNumber(newValue);
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { fieldsValid } = this.state;
        const isValid = Object.values(fieldsValid).every(value => value);
        if (isValid) {
            this.props.handlePaymentSubmit(e);
        } else {
            this.setState({ error: 'Por favor, llena todos los campos correctamente.' })
            setTimeout(() => {
                this.setState({ error: null })
            }, 5000)
        }
    }
    render() {
        // const tab = '\u00A0';
        const { t } = this.props;
        // const promoCode = this.props.promoCode
        return (
            <div className="row-auto">
                <div className="col-md-12">
                    <form method="post" onSubmit={this.handleSubmit}>
                        <div className="form-group">
                            <h2 className="form-group-title">Datos de Pago</h2>
                        </div>
                        <div className="col-xs-12">
                            <div className="form-group">
                                <Input
                                    className="form-control"
                                    onChange={this.props.handleCardName}
                                    placeholder={t('dashboard.room_payment.holder_cname')}
                                    type="text"
                                    value={this.props.cardName}
                                    required
                                    name="cardName"
                                    onValidate={this.handleValidate}
                                />
                            </div>
                        </div>
                        <div className="col-xs-12">
                            <div className="form-group">
                                <Input
                                    className="form-control"
                                    maxLength="19"
                                    onChange={this.handleCardNumber}
                                    placeholder={t('dashboard.room_payment.holder_cnumber')}
                                    type="text"
                                    value={this.props.cardNumber}
                                    name="cardNumber"
                                    onValidate={this.handleValidate}
                                    required
                                />
                                <TypeOfCard number={this.props.cardNumber} />
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-4">
                            <div className="form-group">
                                <Input
                                    className="form-control"
                                    max="12"
                                    min="1"
                                    onChange={this.props.handleCardMonth}
                                    placeholder={t('dashboard.room_payment.holder_cmonth')}
                                    type="number"
                                    value={this.props.cardMonth}
                                    name="cardMonth"
                                    onValidate={this.handleValidate}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-4">
                            <div className="form-group">
                                <Input
                                    className="form-control"
                                    max="99"
                                    min="19"
                                    onChange={this.props.handleCardYear}
                                    placeholder={t('dashboard.room_payment.holder_cyear')}
                                    type="number"
                                    value={this.props.cardYear}
                                    required
                                    name="cardYear"
                                    onValidate={this.handleValidate}
                                />
                            </div>
                        </div>
                        <div className="col-xs-12 col-md-4">
                            <div className="form-group">
                                <Input
                                    className="form-control"
                                    maxLength="4"
                                    onChange={this.props.handleCardCvc}
                                    placeholder={t('dashboard.room_payment.holder_cvc')}
                                    type="number"
                                    value={this.props.cardCvc}
                                    required
                                    name="cardCvc"
                                    onValidate={this.handleValidate}
                                />
                            </div>
                        </div>
                        <div className="col-xs-12">
                            <p>
                                <small className="text-muted">
                                    {t('dashboard.room_payment.security')}
                                </small>
                            </p>
                        </div>
                        <div className="col-xs-12">
                            <div className="form-group">
                                <Input
                                    className="form-control"
                                    onChange={this.props.handleStreetChange}
                                    placeholder={t('dashboard.room_payment.holder_street')}
                                    type="text"
                                    value={this.props.street}
                                    required
                                    name="street"
                                    onValidate={this.handleValidate}
                                />
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-8">
                            <div className="form-group">
                                <Input
                                    className="form-control"
                                    onChange={this.props.handleNeighborhoodChange}
                                    placeholder={t('dashboard.room_payment.holder_neighborhood')}
                                    type="text"
                                    value={this.props.neighborhood}
                                    required
                                    name="neighborhood"
                                    onValidate={this.handleValidate}
                                />
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-4">
                            <div className="form-group">
                                <Input
                                    className="form-control"
                                    onChange={this.props.handlePoChange}
                                    placeholder={t('dashboard.room_payment.holder_po')}
                                    type="number"
                                    value={this.props.po}
                                    required
                                    name="po"
                                    onValidate={this.handleValidate}
                                />
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-8">
                            <div className="form-group">
                                <Input
                                    className="form-control"
                                    onChange={this.props.handleCityChange}
                                    placeholder={t('dashboard.room_payment.holder_city')}
                                    type="text"
                                    value={this.props.city}
                                    required
                                    name="city"
                                    onValidate={this.handleValidate}
                                />
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-4">
                            <div className="form-group">
                                <Input
                                    className="form-control"
                                    onChange={this.props.handleStateChange}
                                    placeholder={t('dashboard.room_payment.holder_state')}
                                    type="text"
                                    value={this.props.state}
                                    required
                                    name="state"
                                    onValidate={this.handleValidate}
                                />
                            </div>
                        </div>
                        {/* <div className="col-xs-12 col-sm-4">
                                    <div className="form-group">
                                        <input
                                            className="form-control"
                                            onChange={this.props.handleCountryChange}
                                            placeholder={t('dashboard.room_payment.holder_country')}
                                            type="text"
                                            value={this.props.country} />
                                    </div>
                                </div> */}
                        <div className="col-xs-12">
                            <div className="form-group">
                                <div className="checkbox">
                                    <label>
                                        <input
                                            type="checkbox"
                                            value=""
                                            required />
                                        {t('dashboard.room_payment.terms')}
                                    </label>
                                </div>
                            </div>
                            <div className="form-group">
                                <div className="checkbox">
                                    <label>
                                        <input
                                            type="checkbox"
                                            value=""
                                            name="require_invoice"
                                            onChange={this.props.handleChecked}
                                        />
                                        {t('venta_linea.payment.require_invoice')}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12">
                            <div className={this.props.error ? "" : "hidden"}>
                                <div className="alert alert-warning">
                                    <i className="glyphicon glyphicon-remove pull-right" onClick={this.props.handleClearError} />
                                    {this.props.error}
                                </div>
                            </div>
                        </div>
                        {/* <div className="data_info_page_promocode">
                            <div className="data_info_page_promocode_center">
                                {this.props.porcentaje_summit
                                    ? (
                                        <div>
                                            <p style={{ textAlign: "center" }}>Porcentaje de Descuento:  {this.props.porcentaje_summit}%</p>
                                        </div>
                                    )
                                    : null
                                }
                                {this.props.porcentaje_summit
                                    ? (
                                        <div>
                                            <p style={{ textAlign: "center" }}>Descuento: {((this.props.porcentaje_summit / 100) * 1990).toFixed(2)}MXN</p>
                                        </div>
                                    )
                                    : null
                                }
                                {this.props.porcentaje_summit
                                    ? (
                                        <div>
                                            <p style={{ textAlign: "center" }}>Total: {((1 - (this.props.porcentaje_summit / 100)) * 1990).toFixed(2)}MXN</p>
                                        </div>
                                    )
                                    : (
                                        <div>
                                            <p style={{ textAlign: "center" }}>Total: 1990 MXN</p>
                                        </div>
                                    )}
                            </div>
                        </div> */}
                        {
                            this.state.error && (
                                <div className="col-xs-12">
                                    <div className="alert alert-danger">
                                        {this.state.error}
                                    </div>
                                </div>
                            )
                        }
                        <div className="form-group col-md-6">
                            <button
                                className="btn btn-default btn-full-width"
                                onClick={this.props.handleReturn}
                                type="button"
                            >
                                <i className="fa fa-arrow-left" aria-hidden="true" /> Atrás
                            </button>
                        </div>
                        <div className="form-group col-md-6">
                            <button
                                className="btn btn-primary btn-full-width"
                                type="submit"
                                disabled={this.props.isPaying}
                            >
                                {!this.props.isPaying ? (
                                    <React.Fragment>
                                        <i className="fa fa-shopping-cart" aria-hidden="true" /> {" "}{t('dashboard.room_payment.btn_pay')}
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        <img
                                            height="20px"
                                            alt={t('dashboard.room_payment.img_spinner')}
                                            src={spinner} /> PROCESANDO PAGO
                                    </React.Fragment>
                                )}
                            </button>
                        </div>
                        {/* <div className="col-xs-12 col-sm-6 text-right">
                                    <img alt={t('dashboard.room_payment.img_credit')} width="150px" src={creditCards} />
                                </div> */}
                    </form>
                </div>
            </div>
        );
    }
}

export default translate('common')(Payment);



// WEBPACK FOOTER //
// ./src/guest/summit/Payment.js